import { render, staticRenderFns } from "./EditReportNarrative.vue?vue&type=template&id=676d9aa3"
import script from "./EditReportNarrative.vue?vue&type=script&lang=js"
export * from "./EditReportNarrative.vue?vue&type=script&lang=js"
import style0 from "./EditReportNarrative.vue?vue&type=style&index=0&id=676d9aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports